export * from "@/ui/components/layout/AnimatedHeaderSection/AnimatedHeaderSection";
export * from "@/ui/components/layout/AnimatedHeaderSection/AnimatedHeaderSection.config";
